export default "__VITE_ASSET__D9gzyVba__"